<div
    class="cell-bordered b-group-game"
    [class.b-group-game_scheduled]="status == 'scheduled'"
    [class.b-match_scheduled]="status == 'scheduled'"
    [class.b-group-game_in_progress]="status == 'in_progress'"
    [class.b-match_in_progress]="status == 'in_progress'"
    [class.highlighted]="highlighted"
    (mouseenter)="mouseEnter($event)"
    (mouseleave)="mouseLeave($event)"
    (click)="open()"
    >
    {{ score }}
</div>
